import { configs } from '../../configs/configs';
const {
    MEMBER_ENROLLMENT,
    MEMBER_APP_LIST,
    CAP_VIEW_MEMBER,
    CAP_COMMENTS,
    SECURE_INBOX,
    CAP_ACCOUNT_ACTIVITY,
    CAP_APPEAL_HISTORY,
    CAP_TICKET_HISTORY,
    INDPORTAL,
    DMI_VERIFICATIONS,
    COMMUNICATION_PREFERENCES_AC,
    VERIFICATION_DOCUMENTS,
    SSAP,
} = configs.routes;

export const allowedRoutes = [
    MEMBER_ENROLLMENT,
    MEMBER_APP_LIST,
    CAP_VIEW_MEMBER,
    CAP_COMMENTS,
    SECURE_INBOX,
    CAP_ACCOUNT_ACTIVITY,
    CAP_APPEAL_HISTORY,
    CAP_TICKET_HISTORY,
    INDPORTAL,
    DMI_VERIFICATIONS,
    COMMUNICATION_PREFERENCES_AC,
    VERIFICATION_DOCUMENTS,
    SSAP,
];
